<template>
  <div class="hello">

    <Header></Header>

    <div class="content_s clearfix">
      <div class="web-info">
        <el-tabs :tab-position="tabPosition"  v-model="activeName" @tab-click="handleClilck">
          <el-tab-pane label="版权声明" name="statement">
            <h2>版权声明</h2>
            <p>中国企业家网上刊载的所有内容，包括但不限于文字报导、图片、声音、录像、图表、标志、标识、广告、商标、商号、域名、软件、程序、版面设计、专栏目录与名称、内容分类标准以及为注册用户提供的任何或所有信息，均受《中华人民共和国著作权法》、《中华人民共和国商标法》、《中华人民共和国专利法》及适用之国际公约中有关著作权、商标权、专利权及/或其它财产所有权法律的保护，为《中国企业家》杂志社有限责任公司或相关权利人专属所有或持有。</p>
            <p>凡中国企业家网站注明“来源：网站原创”或 “来源：中国企业家网”的作品，包括但不限于本网刊载的所有与《中国企业家》杂志内容相关的文字、图片、图表、音频、视频等网上内容，版权均属于《中国企业家》杂志社有限责任公司或相关权利人所有，任何媒体、网站或个人未经《中国企业家》杂志社有限责任公司书面授权不得转载、摘编或利用其它方式使用上述作品;已经书面授权的，应在授权范围内使用，并注明“来源：中国企业家网www.iceo.com.cn”。违反上述声明者，将追究其相关法律责任。</p>
            <p>中国企业家网站未注明“来源：网站原创”或 “来源：中国企业家网www.iceo.com.cn”的作品均为转载稿，本网转载并不意味着认同其观点或真实性。如其他媒体、网站或个人转载使用，应得到相关权利人的许可，依法注明“稿件来源”，并自负法律责任。我们只能在此友情提醒：请自行辨别虚拟网络与真实世界的差别。</p>
            <p>未经《中国企业家》杂志社有限责任公司的书面许可，请勿转载或镜像本站内容，包括但不限于经第三方转载，如经BBS转载。如果您已转载，请删除；且我们保留进一步追究的权利，特此声明。</p>
            <p>我们启用的正式域名为：WWW.ICEO.COM.CN，WWW.CNEMAG.COM，WWW.CNEMAG.COM.CN，并未申请其他任何中英文域名及中文网址。对于您因访问除以上域名以外的同名网站所引起的后果，我们不负任何责任。</p>

          </el-tab-pane>
          <el-tab-pane label="关于我们" name="aboutus">
            <h2 class="titleh2">关于我们</h2>

            <p>
             
              中国企业家杂志创立于1985年，是经济日报社直属期刊，是中国早期以“企业家”命名的杂志之一，在企业家群体中拥有广泛的影响力。
            </p><p>
              近40年来，《中国企业家》已经发展成深受企业家信赖的聚合服务平台，每年举办的中国企业领袖年会（已连续举办21届），中国企业未来之星年会（已连续举办24届），商界木兰年会（已连续举办16届），以及两会沙龙等活动，影响深远。
            </p> <p>
              《中国企业家》杂志社创立了为企业家和创业者输出独特价值的社群，包括中国商界女性领袖颇具影响力的社群木兰汇等。
            </p> <p> 
              《中国企业家》致力“讲好企业家故事 弘扬企业家精神”，拥有杂志、网站、APP，还有微信公众号、微博、抖音号、视频号以及头条号、企鹅号、百家号、强国号等新媒体矩阵，总计粉丝量超过3000万，原创内容年传播量超过10亿人次，具有很强的传播力、引导力、影响力和公信力。
    </p>
               <br>


          </el-tab-pane>
          <el-tab-pane label="加入我们" name="joinus">
            <h2 class="titleh2">加入我们</h2>

            <br />

            <p><strong style="color:#cc0000">联系邮箱：hr@iceo.com.cn　　联系电话：010-63580356</strong></p>
            <br />

          </el-tab-pane>
          <el-tab-pane label="网上公示" name="public">
            <h2 class="titleh2">网上公示</h2>
            <p>根据新闻出版总署、全国&ldquo;扫黄打非&rdquo;工作小组办公室、中央纪委驻新闻出版总署纪检组联合下发的《关于开展打击&ldquo;新闻敲诈&rdquo; &nbsp;治理有偿新闻专项行动的通知》要求，《中国企业家》杂志社认真对照中宣部等四部门印发的《关于禁止有偿新闻的若干规定》和《中宣部、国家广电总局、新闻出版总署关于新闻采编人员从业管理的规定（试行）》等要求，完善内部管理机制，自觉抵制有偿新闻、&ldquo;有偿不闻&rdquo;，坚决清退存在不良行为的采编人员。</p>
            <p>现将《中国企业家》杂志社持有新闻记者证人员名单向全社会公示，以接受社会监督。</p>
            <p>举报投诉电话：（010）63581900</p>
            <p>&nbsp;</p>
            <p>《中国企业家》杂志社持有新闻记者证人员名单：</p>

            <p>钟云华</p>
            <p>李会</p>
            <p>肖小琴</p>
            <p>何伊凡</p>
            <p>马吉英</p>
            <p>米娜</p>
            <p>王怡洁</p>
            <p>梁宵</p>
            <p>李艳艳</p>
            <p>邓双琳</p>
            <p>邓攀</p>
            <p>任娅斐</p>
            <p>胡楠楠</p>
            <p>崔晓燕</p>
            <p>孔月昕</p>
            <p>闫俊文</p>
            <p>郭立琦</p>
            <p>张文静</p>
            <p>李欣</p>
            <p>吴莹</p>
            <p>孙欣</p>
            <p>张秋颖</p>
            <p>苗诗雨</p>
            <p>陈浩</p>



            <p>&nbsp</p><p>&nbsp</p>
            <p><a target="_blank" href="http://www.iceo.com.cn/article/f98fe82d-88f3-40e2-a9e5-287ff0f0d31a" style="color:#003399">《中国企业家》杂志社负责人2018年度薪酬情况公示</a></p>
            <p><a target="_blank" href="http://www.iceo.com.cn/article/d8f9c3bb-611b-4598-8d6e-d27669d321a8" style="color:#003399">经济日报社直属文化企业2019年度工资总额信息披露情况</a></p>
            <p><a target="_blank" href="http://www.iceo.com.cn/article/4bf3e70c-8688-4196-8dd7-5970ea0da333" style="color:#003399">《中国企业家》杂志社负责人2019年度薪酬情况公示</a></p>
            <p><a target="_blank" href="http://www.iceo.com.cn/article/4efbaa94-d26c-4427-9ca6-d3844cfcf88d" style="color:#003399">经济日报社所管理企业2020年度工资分配信息披露</a></p>
            <p><a target="_blank" href="http://www.iceo.com.cn/article/fb2779f3-43a1-464d-9ae2-667f1bc15d9b" style="color:#003399">《中国企业家》杂志社负责人2020年薪酬情况公示表</a></p>

          </el-tab-pane>
          <el-tab-pane label="广告服务" name="abinfo">

            <h2 class="titleh2">刊登广告须知</h2>
<p>&middot; 《中国企业家》为月刊，每月5号出刊</p>
<p>&middot; 在本刊刊登广告需遵守《中华人民共和国广告法》等相关法规</p>
<p>&middot; 出刊前15日截止下期广告材料</p>
<p>&middot; 所有广告材料需要提供彩色打样，若无彩色打样则以印出效果为准</p>
<p>&middot; 电子文件请在出刊15日前转发给本刊广告部。设计中心适用文件标准：Adobe Photoshop文件 PCI Freehand文件 Adobe  Pagemaker文件，分辨率300以上(TIF、JPG)格式。如提供四色菲林，要求线数175</p>
<p>&middot; 委托本刊设计，设计费不低于版面报价的5%</p>
<p>&middot; 撤销广告，须提前30天以书面形式通知本刊广告部，否则，需支付50%的广告合同额做违约金</p>
<p>&middot; 有广告客户提供的相关广告材料发布后，如发生版权问题，本刊不承担法律责任</p>
<p>&middot; 预定广告需与杂志社签订书面合同</p>
<p>&middot; 因杂志社原因导致的广告发布错误，由杂志社免费补登该广告做补偿。相反由广告客户或其代理广告公司的原因出 现广告图文出错，本刊免责</p>
<p>&middot; 本刊在广告刊出后有权处理广告材料，若需收回请及时书面通知本社，否则，遗失，损坏，本刊概不负责</p>
<p>&middot; 刊登的广告内容、形式等不符合本刊要求的，本刊有权拒绝刊登</p>
<p>&middot; 此广告价格表从2012年1月1日开始生效，此前印刷的《中国企业家》广告价目表及说明停止使用。</p>
<p style="text-align: center;">&nbsp;</p>

          </el-tab-pane>
          <el-tab-pane label="联系我们" name="contact"> 
            <h2 class="titleh2">联系我们</h2>

            <p>《中国企业家》杂志社 China Entrepreneur Magazine</p>
            <p>地址：北京西城区白纸坊东街2号经济日报社东门</p>
            <p>总机：010-63582109</p>
            <p>发行电话：010-64923579</p>
            <p>编辑部电话：010-63584726</p>
            <p>印刷 北京利丰雅高长城印刷有限公司</p>

          </el-tab-pane>
          <el-tab-pane label="杂志订阅"  name="subscription">
            <h2 class="titleh2">杂志订阅</h2>
            <p><strong>一、杂志简介</strong></p>
            <p>
              《中国企业家》杂志创刊于1985年，隶属于经济日报社，是关注企业家群体的一本杂志。杂志秉承 “讲好企业家故事，弘扬企业家精神” 的理念，以做最懂企业家的内容生产者为追求，以“讲好企业家故事、弘扬企业家精神、凝聚企业家力量”为核心理念，致力于推动商业文明建设，使企业家阶层成为中国社会受尊重的主流人群。
            </p>
            <p>
              经过35年的积淀，杂志社已成长为以采编内容(含杂志、两微一端、第三方平台)、智库/学院(培训课程、会议活动、榜单案例)和社群活动(《中国企业家》俱乐部、两会沙龙、未来之星、木兰汇、企业领袖等)三大业务为核心的、集学习社交赋能共生为一体的、具有影响力的中国企业家创新聚合平台。
            </p>
            <p>&nbsp;</p>
            <p><strong>二、出版信息</strong></p>
            <p>主办/主管：经济日报社</p>
            <p>出版单位：《中国企业家》杂志社有限责任公司 </p>
            <p>出版周期：月刊 </p>
            <p>全年期数：12 </p>
            <p>出版日期：每月5日 </p>
            <p>单期定价：人民币40元 </p>
            <p>邮发代号：2-873 </p>
            <p>国内统一刊号：CN11-1269/F  </p>
            <p>国际标准刊号：ISSN1003-5087 </p>
            <p>广告许可证号：京朝工商广字第8083号 </p>
            <p>&nbsp;</p>
            <p><strong>三、订阅渠道</strong></p>
            <p>
              <strong>1、全国邮政订阅热线：11185</strong>（读者朋友，也可到当地邮局订阅，本刊邮发代号：2-873）
            </p>
            <p><strong>2、网上订阅：</strong> 有赞商城<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;店铺网址 <a target="_blank" href="https://shop44045983.m.youzan.com/wscgoods/detail/2ogmod8y2z593el">https://shop44045983.m.youzan.com/wscgoods/detail/2ogmod8y2z593el</a></p>
            
            <p>&nbsp;</p>
            <p><strong>四、联系我们</strong></p>
            <p>电话订阅热线：010-64923579</p>
            <p>发行联系邮箱：faxing@iceo.com.cn（请标注公司名称+姓名+合作/咨询内容）</p>
            <p>&nbsp;</p>

            <p><strong>五、汇款账户</strong></p>
            <p>收款方账号名称：《中国企业家》杂志社有限责任公司</p>
            <p>纳税人识别号：911100004000049400 </p>
            <p>开户银行：建设银行菜市口南街支行 </p>
            <p>开户行账号：11050167750000000934 </p>

          </el-tab-pane>
          <el-tab-pane label=" 友情链接" name="link">

            <h2 class="titleh2">财经媒体</h2>
            <h3> 【资讯】 </h3>
            <ul class="friends_links clearfix">
              <li><a target="_blank" href="http://www.21so.com/">21财经搜索</a></li>
              <li><a target="_blank" href="http://www.cb.com.cn/">中国经营报社网站</a></li>
              <li><a target="_blank" href="http://www.ceconline.com/">世界经理人网</a></li>
              <li><a target="_blank" href="http://www.nbd.com.cn/">每日经济新闻网</a></li>
              <li><a target="_blank" href="http://www.bnet.com.cn/">BNET商业英才网</a></li>
              <li><a target="_blank" href="http://www.chinavalue.net/Index.html">价值中国网</a></li>
              <li><a target="_blank" href="http://www.sina.com.cn">新浪</a></li>
              <li><a target="_blank" href="http://www.163.com/">网易</a></li>
              <li><a target="_blank" href="http://www.qq.com/">腾讯</a></li>
              <li><a target="_blank" href="http://www.hexun.com/">和讯</a></li>
              <li><a target="_blank" href="http://finance.sina.com.cn/">新浪财经</a></li>

              <li><a target="_blank" href="http://finance.ifeng.com/">凤凰财经</a></li>
              <li><a target="_blank" href="http://www.hao123.com/">hao123导航</a>    </li>
              <li><a target="_blank" href="http://money.163.com/">网易财经</a></li>
              <li><a target="_blank" href="http://finance.qq.com/">腾讯财经</a></li>
              <li><a target="_blank" href="http://tech.163.com/">网易科技</a></li>
              <li><a target="_blank" href="http://finance.huanqiu.com/">环球网财经</a></li>
              <li><a target="_blank" href="http://www.yicai.com/">一财网</a></li>
              <li><a target="_blank" href="http://www.jrj.com.cn/">金融界</a></li>
              <li><a target="_blank" href="http://www.eeo.com.cn/">经济观察网</a></li>
              <li><a target="_blank" href="http://www.caixin.cn/">财新网</a></li>

              <li><a target="_blank" href="http://gb.cri.cn/">国际在线</a></li>
              <li><a target="_blank" href="http://www.591hx.com/">华讯财经</a></li>
              <li><a target="_blank" href="http://www.ce.cn/">中国经济网</a></li>
              <li><a target="_blank" href="http://www.58188.com/">顶尖财经</a></li>
              <li><a target="_blank" href="http://ceibsreview.com/">中欧商业在线</a></li>

              <li><a target="_blank" href="http://www.china.com.cn/economic/node_5001716.htm">中国网财经</a></li>

              <li><a target="_blank" href="http://www.17ok.com/">财界网</a></li>


              <li><a target="_blank" href="http://www.cfi.net.cn/">中国财经信息网</a></li>

              <li><a target="_blank" href="http://www.chinavalue.net/">价值中国</a></li>

              <li><a target="_blank" href="http://www.cyzone.cn/">创业邦</a></li>
              <li><a target="_blank" href="http://www.zjol.com.cn/">浙江在线</a></li>
              <li><a target="_blank" href="http://www.southmoney.com/">南方财富网</a></li>
              <li><a target="_blank" href="http://www.northnews.cn/">北方新闻网</a></li>


              <li><a target="_blank" href="http://manage.org.cn/">中国管理传播网</a></li>

              <li><a target="_blank" href="http://money.ycwb.com/">金羊财经</a></li>



              <li><a target="_blank" href="http://www.hb261.com/">河北金融网</a></li>


              <li><a target="_blank" href="http://www.afinance.cn/">第一金融网</a></li>
              <li><a target="_blank" href="http://www.sci99.com">卓创资讯</a></li>


              <li><a target="_blank" href="http://www.jingji.com.cn">《经济》杂志</a></li>
              <li><a target="_blank" href="http://www.cneo.com.cn">企业观察网</a></li>
            </ul>
            <h3> 【投资】 </h3>
            <ul class="friends_links clearfix">
              <li><a target="_blank" href="http://www.cnfol.com/">中金在线</a></li>
              <li><a target="_blank" href="http://www.eastmoney.com/">东方财富网</a></li>
              <li><a target="_blank" href="http://www.cnstock.com/">中国证券网</a></li>
              <li><a target="_blank" href="http://www.gw.com.cn/">大智慧</a></li>
              <li><a target="_blank" href="http://www.10jqka.com.cn/">同花顺</a></li>
              <li><a target="_blank" href="http://www.zgjrw.com/">中国金融网</a></li>

              <li><a target="_blank" href="http://www.cnfund.cn/">中国基金网</a></li>


              <li><a target="_blank" href="http://www.chinaventure.com.cn/">投资中国</a></li>



              <li><a target="_blank" href="http://www.pedaily.cn/">投资界</a></li>


              <li><a target="_blank" href="http://www.yidaba.com/">一大把网</a></li>
              <li><a target="_blank" href="http://www.cmmo.cn/">第一营销网</a></li>
              <li><a target="_blank" href="http://www.huishangol.com">徽商网</a></li>

              <li><a target="_blank" href="http://www.wlstock.com">万隆证券网</a></li>
              <li><a target="_blank" href="http://www.qjxgold.com/">仟家信</a></li>
            </ul>
            <h3> 【其他】 </h3>
            <ul class="friends_links clearfix">
              <li><a target="_blank" href="http://www.pinganlife.cn/">中国平安保险在线</a></li>
              <li><a target="_blank" href="http://www.workws.com/">华尔街招聘网</a></li>
              <li><a target="_blank" href="http://www.hq88.com/">华企在线商学院</a></li>
              <li><a target="_blank" href="http://www.lietou.com/">猎头网</a></li>

              <li><a target="_blank" href="http://www.yesky.com/">天极网</a></li>

              <li><a target="_blank" href="http://www.fire.hc360.com/">慧聪消防网</a></li>

              <li><a target="_blank" href="http://www.xlysauc.com/">西泠印社拍卖</a></li>
              <li><a target="_blank" href="http://www.zjpark.com/">张江高科孵化器</a></li>
              <li><a target="_blank" href="http://www.cnforex.com/">环球外汇</a></li>

              <li><a target="_blank" href="http://www.bfscc.com/">金融街在线</a></li>
              <li><a target="_blank" href="http://www.loanchina.com">易贷中国贷款</a></li>

              <li><a target="_blank" href="http://www.gucheng.com">股城网</a></li>
              <li><a target="_blank" href="http://www.vobao.com/">沃保网</a></li>

              <li><a target="_blank" href="http://www.allchina.cn/">媒体资源网</a></li>
              <li><a target="_blank" href="http://www.lmtw.com/">流媒体网</a></li>

              <li><a target="_blank" href="http://www.jibi.net/">中国集币在线</a></li>


            </ul>
          </el-tab-pane>

        </el-tabs>
      </div>
  </div>
  <bbottom></bbottom>
  </div>
</template>

<script>
  import Header from "@/components/public/Header.vue"
  import bbottom from "@/components/public/bbottom.vue"
  export default {
    name: 'Active',
    data() {
      return {
        tabPosition: 'left',
        fullscreenLoading: false,
        activeName: 'first'
      }
    },

    props: {

    },

    created(){
        if(this.$route.params.section) {
          this.activeName = this.$route.params.section;
        }else{
            this.activeName = 0;
        }
    },
    watch: {
      '$route': function(to, from) {
        window.location.reload()
        }
    },

    //页面初始化
    computed: {
     
    },

    //页面加载后执行方法
    methods: {
      handleClilck(){

      }
    },
    //组件引入
    components: {
      Header,
      bbottom
    },
  }

</script>

<style scoped>

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .content_s {
    width: 1200px;
    margin: 25px auto;
    color: #4b4b4b;
  }

  .img_s {
    width: 100%;
    border-radius: 6px;
  }


  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 100%;
    display: block;
    border-radius: 6px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .item h3 {
    color: #e85a50;
  }

  .icon_s {
    display: inline-block;
    width: 30px;
    height: 30px;
    background: #eea01e;
    text-align: center;
    line-height: 30px;
    border-radius: 10px;
    margin-right: 15px;
    /* color:#fa5c00; */
    color: white;
  }

  .text {
    font-size: 14px;
  }

  .item {
    padding: 18px 0;
  }

  .box-card {
    width: 100%;
    margin-bottom: 20px;
  }

  .el-row {
    margin-bottom: 0px;
  }

  .el-col {
    /* margin-right:30px; */
    border-radius: 4px;
  }


  .el-icon-caret-right:before {
    color: #bd0c16 !important;
    font-size: 16px !important;
    line-height: 20px
  }

  .mag-r .act-list .el-icon-caret-right:before {
    color: #bd0c16 !important;
    font-size: 30px !important;
    line-height: 30px
  }

  .el-button--default {
    background-color: #bd0c16;
    width: 130px;
    height: 40px;
    color: #ffffff;
    font-size: 18px;
    margin-top: 30px;
  }


  .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
    font-size: 18px !important;
    font-weight: normal !important;
  }


  .el-button--primary {
    background-color: #ffffff;
    border: 1px solid #f1f1f1;
    font-size: 18px;
    color: #999;
    display: block;
    margin: 35px auto;
  }
  .el-tabs__content h2 {
   
    font-size: 18px;
    color: #4b4b4b;
    padding: 0px;
    margin:20px auto 10px;
  }
  .el-tabs__content h3 {
    font-size: 16px;
    color: #4b4b4b;
    padding: 0px;
    margin: 20px auto ;
  }
  .el-tabs__content p{
    font-size:14px;
    line-height:28px;
  }
  .friends_links {
    margin: 0 auto;
    width: 100%;
    padding:0px;
  }
    .friends_links  li {
      float: left;
      margin-right: 30px;
      margin-bottom: 10px;
      list-style:none;
      line-height:24px;
    }
    .friends_links li a{
     color:#4b4b4b;
     text-decoration:none;
    }
</style>



// WEBPACK FOOTER //
// src/components/info.vue